/**
 * Ajax function to grab gallery set images and put in modal.
 * @param  {INT} post_id
 * @param  {INT} gallery_id
 * @return {String}            The gallery
 */
function wu_get_gallery_images(image, start) {
    $('body').append('<div class="modal fade" id="modal-gallery"><div class="modal__loading"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div><a href="#" class="modal__close"><span class="burger"></span></a><div class="modal__gallery"><div class="modal__gallery__images"></div></div></div>');
    $('#modal-gallery').modal('show').on('hidden.bs.modal', function (e) {
      $(this).remove();
    });
    image.parents('.content__module--gallery').find('.gallery__image').each(function(index, el) {
        var src = $(this).attr('data-src'),
            title = $(this).attr('title'),
            caption = $(this).attr('data-caption');
        $('.modal .modal__gallery .modal__gallery__images').append('<div><div class="modal__gallery__image"><img data-lazy="' + src + '" alt=""/><div class="modal__gallery__image__caption">' + caption + '</div></div></div>');
    });


    $('.modal__gallery').on('lazyLoaded', function(event, slick, currentSlide, nextSlide) {
        $('.modal').addClass('loaded');
    });


    $('.modal__gallery__images').slick({
        prevArrow: '<a href="#" class="previous" aria-label="Previous"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a href="#" class="next" aria-label="Next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        dots: false,
        infinite: true,
        speed: 1300,
        variableWidth: true,
        lazyLoad: 'progressive',
    }).slick('slickGoTo', start);

    $(document).on('click', '.modal__close', function(event) {
        event.preventDefault();
        $('#modal-gallery').modal('hide')
    });

}

$(document).on('click', '.gallery__image', function(event) {
    event.preventDefault();
    var start = parseInt($(this).attr('data-slide'));
    console.log(start);
    wu_get_gallery_images($(this), start);
});
